import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=af7fa86a&scoped=true&"
import script from "./GalleryItem.vue?vue&type=script&lang=js&"
export * from "./GalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&id=af7fa86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7fa86a",
  null
  
)

component.options.__file = "GalleryItem.vue"
export default component.exports